module.exports = __webpack_public_path__ + "img/team.b081ec21.jpeg";